@import 'styles/mixins';
@import 'styles/variables';

:global(.ProseMirror).showDecorations {
  .insertion {
    &.pilcrow.nonEmpty::after,
    &.paragraph.empty::before {
      content: '\00B6';
      color: $grass-60;
      border-bottom: 2px solid $green-60;
      margin-bottom: -2px;
      & > br:global(.ProseMirror-trailingBreak):only-child {
        display: none;
      }
    }

    &.pilcrow.nonEmpty.selected::after {
      content: none;
    }

    &.paragraph.empty {
      &.selected {
        background: $grass-10;
      }
      &.selected,
      &:last-child {
        &::before {
          content: none;
        }
      }
    }

    &.smartLink {
      a {
        color: $grass-60;
        border-bottom: 2px solid $grass-60;
      }

      &.selected {
        a {
          background-color: $grass-10;
        }
      }
    }

    &.image img,
    &.table table,
    &.leafBlock,
    &.defaultBlock {
      outline: 2px solid $green-60;
    }

    &:is(td) {
      li {
        --marker-font-color: #{$grass-60} !important;
      }

      p:not(.empty) {
        color: $grass-60;
      }
    }

    &.listItem {
      &:before {
        --marker-font-color: #007e7b;
      }

      &.selected {
        background: $grass-10;
      }
    }
  }

  .beforeDeletion {
    &.pilcrow {
      display: inline-block;
    }
    &.empty.paragraph {
      display: inline-block;
      &::after {
        content: '\00B6';
        color: $red-60;
        text-decoration: line-through;
        text-decoration-thickness: 2px;
      }
      & > br:global(.ProseMirror-trailingBreak):only-child {
        display: none;
      }
    }
  }
  .deletion {
    &.paragraph {
      display: inline-block;
    }
    &.pilcrow {
      display: inline-block;
      & > br:global(.ProseMirror-trailingBreak):only-child {
        display: none;
      }
      &::after {
        content: '\00B6';
        color: $red-60;
        text-decoration: line-through;
        text-decoration-thickness: 2px;
      }
      & + :global(.ProseMirror-widget) {
        display: none;
        & + :is(p, h1, h2, h3, h4, h5, h6) {
          display: inline-block;
        }
      }
      & + :is(p, h1, h2, h3, h4, h5, h6) {
        display: inline-block;
      }
    }

    &.paragraph.empty.selected {
      background: $red-20;
    }

    &.paragraph.empty {
      display: inline-block;
      &::after {
        content: none;
      }
      &::before {
        content: '\00B6';
        color: $red-60;
        text-decoration: line-through;
        text-decoration-thickness: 2px;
      }
    }

    &.smartLink {
      a {
        color: $red-60;
        text-decoration: line-through;
        text-decoration-thickness: 2px;
      }

      &.selected {
        a {
          background-color: $red-20;
        }
      }
    }

    &.image img,
    &.table table,
    &.leafBlock,
    &.defaultBlock {
      outline: 2px solid $red-60;
    }

    &.listItem {
      &:before {
        --marker-font-color: #aa2b24;
        text-decoration: line-through;
        text-decoration-thickness: 2px;
      }

      &.selected {
        &:before {
          background: $red-20;
        }
      }
    }
  }

  .node_type_change {
    &.heading,
    &.paragraph {
      color: $grass-60;
      border-bottom: 2px dashed $green-60;

      &.selected {
        background: $grass-10;
      }
    }

    &.leafBlock,
    &.defaultBlock,
    &.image img,
    &.table table {
      outline: 2px dashed $green-60;
    }
  }
}

:global(.ProseMirror).hideDecorations {
  .deletion.defaultBlock:is(p, h1, h2, h3, h4, h5, h6) {
    display: inline-block;
  }
  .deletion.empty,
  .deletion[data-node-type='table'],
  .deletion.defaultBlock,
  .deletion.image,
  .deletion.smartLink,
  .deletion.leafBlock {
    display: none;
  }
  .beforeDeletion,
  .deletion {
    &.paragraph.nonEmpty {
      display: inline-block;
      &.pilcrow {
        display: inline-block;

        &,
        & + .empty.pilcrow.deletion,
        & + :global(.ProseMirror-widget) {
          & + .nonEmpty:is(p, h1, h2, h3, h4, h5, h6) {
            display: inline-block;
          }
        }
      }
    }
  }

  ul,
  ol {
    &[data-type] > li.deletion.empty {
      display: none;
    }
  }
}
